<template>
 <span v-if="end" class="quote-sign">”</span>
 <span v-else class="quote-sign">“</span>
</template>
<script>
export default {
  props: {
    end: Boolean
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .quote-sign {
    font-family: 'Times New Roman', Times, serif;
    font-size: @font-size-large;
    color: #888;
  }
</style>
